import ESelectLanguage from '@/components/everridge/ESelectLanguage';
import LogoIcon from '@/components/icons/LogoIcon';
import OwnInnIcon from '@/components/icons/OwnInnIcon';
import { AppConfig } from '@/config/app.config';
import useMediaQuery from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils';

const AuthorizationHeader = () => {
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

	return (
		<div className={cn('fixed z-10 w-full', isMobile && 'border-b')}>
			<header
				className={cn(
					'py-4 bg-trasparent border-b border-transparent',
					isMobile ? 'px-4' : 'px-8',
				)}>
				<div className='flex items-center justify-between gap-2 '>
					<div
						className={
							'flex items-center gap-2 select-none cursor-pointer mr-auto'
						}>
						{isMobile ? (
							<OwnInnIcon className='size-6' />
						) : (
							<LogoIcon />
						)}
						<h1
							className={cn(
								isMobile
									? 'text-lg font-semibold text-popover-1000'
									: 'text-xl font-bold text-popover-10',
							)}>
							OwnInn
						</h1>
					</div>
					<div className={'flex gap-4'}>
						<ESelectLanguage />
					</div>
				</div>
			</header>
		</div>
	);
};

export default AuthorizationHeader;
